import React from "react";
import "./CustomModal.css";

const CustomModal = ({ show, setShow, title, children, footer, size = "md" }) => {
  if (!show) return null;

  return (
    <div className="custom-modal-overlay" onClick={() => setShow({ isOpen: false })}>
      <div 
        className={`custom-modal-container ${size}`} 
        onClick={(e) => e.stopPropagation()}
      >
        <div className="custom-modal-header">
          <h5 className="custom-modal-title">{title}</h5>
          <button className="custom-modal-close" onClick={() => setShow({ isOpen: false })}>
            &times;
          </button>
        </div>
        <div className="custom-modal-body">
          {children}
        </div>
        {footer && <div className="custom-modal-footer">{footer}</div>}
      </div>
    </div>
  );
};

export default CustomModal;
